import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { EnvelopeSimple, ArrowRight } from "@phosphor-icons/react";

export default function NewsletterSignup({ source = "landing", variant = "light" }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter/subscribe", { email, source });
      setDone(true);
      toast.success("Subscribed! Check your inbox.");
      setEmail("");
    } catch (e) {
      toast.error("Could not subscribe");
    } finally {
      setBusy(false);
    }
  };

  const isDark = variant === "dark";

  return (
    <div className={isDark ? "text-white" : ""}>
      <div className={`text-xs uppercase tracking-[0.2em] font-semibold mb-2 ${isDark ? "text-slate-300" : "text-slate-500"}`}>
        <EnvelopeSimple size={14} className="inline mr-1" /> Get the CanHireSolution newsletter
      </div>
      <p className={`text-sm mb-3 ${isDark ? "text-slate-200" : "text-slate-700"}`}>
        Tips, trends, and hiring guides for Canadians. No spam, ever.
      </p>
      {done ? (
        <div className={`text-sm font-semibold ${isDark ? "text-emerald-300" : "text-emerald-700"}`}>✓ Thanks — you&apos;re on the list.</div>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 max-w-md">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.ca"
            className={`flex-1 px-3 py-2.5 text-sm border ${isDark ? "bg-white/10 border-white/20 text-white placeholder:text-slate-400" : "bg-white border-slate-300"}`}
            data-testid="newsletter-email"
          />
          <button type="submit" disabled={busy} className="bg-accent-red text-white px-5 py-2.5 text-sm font-semibold flex items-center justify-center gap-1 disabled:opacity-50 hover:bg-[#D55915]" data-testid="newsletter-submit">
            {busy ? "…" : "Subscribe"} <ArrowRight size={14} weight="bold" />
          </button>
        </form>
      )}
    </div>
  );
}
